import { createFormContext } from '@mantine/form';

import { PrincipalAssignmentFormType } from './types';

// You can give context variables any name
export const [PrincipalAssignmentFormProvider, usePrincipalAssignmentFormContext, usePrincipalAssignmentForm] =
    createFormContext<PrincipalAssignmentFormType>();
